import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
let holidaysPromise = null;

export const refreshHolidays = () => { holidaysPromise = null; };

// Festivos del centro (Configuración > Centro > Horario laboral) como { 'YYYY-MM-DD': nombre }.
export function useHolidays() {
  const [map, setMap] = useState({});
  useEffect(() => {
    if (!holidaysPromise) {
      holidaysPromise = axios.get(`${API_URL}/api/config/working-hours`, { withCredentials: true })
        .then(r => Object.fromEntries((r.data?.holidays || []).map(h => [h.date, h.name || 'Festivo'])))
        .catch(() => { holidaysPromise = null; return {}; });
    }
    holidaysPromise.then(setMap);
  }, []);
  return map;
}

export function HolidayWarning({ date, lang }) {
  const holidays = useHolidays();
  const name = date && holidays[date];
  if (!name) return null;
  return (
    <div className="px-3 py-2 rounded-sm border border-amber-300 bg-amber-50 text-xs text-amber-800" data-testid="appt-holiday-warning">
      {lang === 'es' ? `Atención: el ${date} es festivo (${name}). El centro está cerrado ese día.` : `Warning: ${date} is a holiday (${name}).`}
    </div>
  );
}
